import React from 'react'
import InlineCredits from './inline-credits'

const TitleCredits = ({ title, artist, year, credit, style }) => (
    <>
        <div className="title" style={style}>
            {(title && artist && year) && 
                <>{artist}, <em>{title}</em>, {year}</>
            }
            <InlineCredits credit={credit} />
        </div>
    </>
)

export default TitleCredits